import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const addToWishListFn = (redBody) => {
  try {
    const response = axiosInstance.post(API_URLS.addToWishList, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
